<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-university"></i> PA</h3>
      </div>
    </div>
    <PAAdd v-if="showAdd" ref="PAAdd" v-on:Back="onBack" />
    <PAList v-else ref="PAList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import PAAdd from './components/add/paadd.vue'
import PAList from './components/list/palist.vue'

export default {
  name: 'Pa',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    PAAdd,
    PAList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.PAAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.PAList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/pa/pa.vue